<template>
  <div>
    <!-- todo - https://stackoverflow.com/questions/50392918/vuetify-how-to-preselect-active-tab
     -->
    <v-tabs v-model="activetab" align-with-title class="mt-n2 pb-0 tab-headers-details">
      <!-- eslint-disable-next-line max-len -->
      <v-tab v-for="tab of tabs" class="common-font-size" :key="tab.id" @click="WarnUser(tab.to)" :id="`mtgTransSequenceTab${tab.id}`"
        :class="`mtg-trans-sequence-tab-${tab.id}`">
        <span>{{ tab.caption }}</span>
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>
import CommonDropDownsMixins from '../components/tax/common-utils/CommonDropDowns.mixin.vue';
import '../assets/style.css';

export default {
  name: 'MortgageCoProcessing',
  mixins: [CommonDropDownsMixins],
  components: {
  },
  created() {
    this.getPathName(this.$route.path);
    this.loadDropDownList();
  },
  data: () => ({
    dialog: false,
    path: '',
    activetab: 0,
    tabs: [
      { id: 1, to: { path: '/tax/mortgageco/billrequests' }, caption: 'Bill Requests' },
      { id: 2, to: { path: '/tax/mortgageco/payments' }, caption: 'Payments' },
      { id: 3, to: { path: '/tax/mortgageco/lockbox' }, caption: 'Lockbox' },
      { id: 4, to: { path: '/tax/mortgageco/export' }, caption: 'Export' },
    ],
  }),
  methods: {
    async loadDropDownList() {
      this.loadTaxYearList({ postProcessTrans: this.postProccessTaxYearData });
      await this.loadTaxMortgageCodesSharedRecords(
        {
          criteria: {
            sortBy: [{
              column: 'mtgCode',
              direction: 'asc',
            }],
          },
          postProcessTrans: this.postProccessMTGData,
          isItSetState: true,
        },
      );
    },
    getPathName(curPath) {
      const ftr = this.tabs.filter((ft) => ft.to.path === curPath);
      this.activetab = ftr[0].id !== undefined ? ftr[0].id - 1 : 0;
    },
    WarnUser(path) {
      this.path = path;
      const currentpath = this.$router.currentRoute.path;
      if (path.path !== currentpath) {
        this.$router.push(path);
      }
    },
  },
  // computed: {
  // },
};
</script>
